import React from 'react';

interface ArrowDownIconProps {
	className?: string;
}

export const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({ className = 'u-icon u-icon--arrow-down' }) => (
	<svg
		className={className}
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M7 14L0 7L1.63333 5.36667L5.83333 9.56667V0H8.16667V9.56667L12.3667 5.36667L14 7L7 14Z"
			fill="currentColor"
		/>
	</svg>
);

export const NotificationDot: React.FC<{ className?: string }> = ({ 
	className = 'c-menu-link-notification' 
}) => (
	<i className={className} />
); 